import type { SiteConfig } from '../../../siteContentTypes.ts';
import { TextField, ImageField } from './fields.tsx';

export function GeneralSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const g = config.general;
  const set = (patch: Partial<SiteConfig['general']>) => update({ general: { ...g, ...patch } });
  const setSocial = (patch: Partial<SiteConfig['general']['socialLinks']>) =>
    set({ socialLinks: { ...g.socialLinks, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Général</h2>
      <TextField label="Nom de la plateforme" value={g.platformName} onChange={(v) => set({ platformName: v })} />
      <ImageField label="Logo principal" value={g.logoUrl} onChange={(v) => set({ logoUrl: v })} />
      <ImageField label="Logo (version sombre)" value={g.logoDarkUrl} onChange={(v) => set({ logoDarkUrl: v })} />
      <ImageField label="Favicon" value={g.faviconUrl} onChange={(v) => set({ faviconUrl: v })} />
      <TextField label="Slogan" value={g.slogan} onChange={(v) => set({ slogan: v })} />
      <TextField label="Description courte" value={g.shortDescription} onChange={(v) => set({ shortDescription: v })} />
      <TextField label="Email de contact" value={g.contactEmail} onChange={(v) => set({ contactEmail: v })} />
      <TextField label="Téléphone" value={g.contactPhone} onChange={(v) => set({ contactPhone: v })} />
      <TextField label="Facebook" value={g.socialLinks.facebook} onChange={(v) => setSocial({ facebook: v })} />
      <TextField label="Instagram" value={g.socialLinks.instagram} onChange={(v) => setSocial({ instagram: v })} />
      <TextField label="LinkedIn" value={g.socialLinks.linkedin} onChange={(v) => setSocial({ linkedin: v })} />
      <TextField label="Twitter / X" value={g.socialLinks.twitter} onChange={(v) => setSocial({ twitter: v })} />
      <TextField label="Copyright" value={g.copyrightText} onChange={(v) => set({ copyrightText: v })} />
    </div>
  );
}
